<router-outlet></router-outlet>
<ngx-spinner bdColor = "rgba(56,110,73, 0.5)" type="ball-clip-rotate-multiple" size="medium"></ngx-spinner>
